import styled from 'styled-components';
import * as tokens from '../../tokens';

export const totalWrapper = styled.div`
  width: 100%;
  height: 2500px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;
export const buttonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 810px;
`;
export const buttoncruiting = styled.div`
  height: 45px;
  width: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #dd518c;
  font-size: 25px;
  font-weight: bold;
  margin-left: 350px;
  padding: 10px;
  border-style: solid;
  border-color: #dd518c;
  border-width: 2px;
  border-radius: 30px;
  box-shadow: 0px 2px 1px rgba(0, 0, 0, 0.2);
  cursor: pointer;
`;
